module.exports = __webpack_public_path__ + "img/SSLRPICK.80d544da.svg";